export const ECARMEN_ENDPOINTS = {
  careers: '/api/core/v3/student_app/?tab=career',
  education: '/api/core/v3/student_app/?tab=education',
  feeds: '/api/core/v3/student_app/feeds',
  tuition: '/api/core/v3/student_app/tuition_reference',
}

export const ACCOUNTS_ENDPOINTS = {
  authenticateWithEmail: '/users/authenticate/email',
  checkEmailInput: '/users/checkEmailInput',
  emailLinkSignon: '/users/trigger-emaillink-signon',
  login: '/users/sso/login',
  ssoCheck: '/users/sso/check',
  ssoLogout: '/users/sso/logout',
}


// WEBPACK FOOTER //
// ./src/utils/constants/endpoints.js